




































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SupervisiLaundryService from "@/services/SupervisiLaundryService";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";
import { appModule } from "@/store/modules/app";

interface ChecklistItem {
  key: string;
  label: string;
}

interface ChecklistSection {
  code: string;
  title: string;
  items: ChecklistItem[];
}

const JAM_CARRIER = toDateString(new Date()) || "2000-01-01";

@Component({ components: { VCDateTimePicker } })
export default class SupervisiLaundryFormDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: null }) editData!: any;

  saving = false;

  form: any = {};

  sectionI: ChecklistItem[] = [
    { key: "s1_pintu_berbeda", label: "Pintu penerimaan dan pendistribusian berbeda" },
    { key: "s1_lokasi_proses_berbeda", label: "Lokasi masing-masing proses berbeda (penerimaan, penghitungan dan penimbangan terpisah dengan linen bersih)" },
  ];

  sectionII: ChecklistItem[] = [
    { key: "s2_sarana_cuci_tangan", label: "Tersedia sarana cuci tangan lengkap" },
    { key: "s2_apd_lengkap", label: "Tersedia APD lengkap" },
    { key: "s2_tempat_penyimpanan_b3", label: "Ada tempat penyimpanan B3" },
    { key: "s2_temperature_ruang_bersih", label: "Temperature ruang bersih 22°C – 27°C" },
    { key: "s2_linen_tidak_berserakan", label: "Linen tidak berserakan di lantai" },
  ];

  sectionIII: ChecklistItem[] = [
    { key: "s3_one_day_service", label: "Pelayanan linen bersih one day servis" },
    { key: "s3_bukti_pemeriksaan_air_panas", label: "Ada bukti hasil pemeriksaan air panas" },
    { key: "s3_dokumen_pendistribusian", label: "Ada dokumen pendistribusian" },
    { key: "s3_petugas_apd_sesuai", label: "Petugas memakai APD yang sesuai" },
    { key: "s3_proses_sesuai_prosedur", label: "Proses pencucian sampai dengan pendistribusian berjalan sesuai prosedur" },
  ];

  created() {
    this.form = this.getEmptyForm();
  }

  get dialogVisible() {
    return this.value;
  }

  set dialogVisible(val: boolean) {
    this.$emit("input", val);
  }

  get isEdit() {
    return this.editData && this.editData.id;
  }

  get sections(): ChecklistSection[] {
    return [
      { code: "s1", title: "I. SUPERVISI ALUR", items: this.sectionI },
      { code: "s2", title: "II. SUPERVISI FASILITAS DAN KEBERSIHAN", items: this.sectionII },
      { code: "s3", title: "III. SUPERVISI PROSES", items: this.sectionIII },
    ];
  }

  get allItems(): ChecklistItem[] {
    return this.sections.reduce(
      (acc: ChecklistItem[], s: ChecklistSection) => acc.concat(s.items),
      []
    );
  }

  setNilai(key: string, val: boolean) {
    this.$set(this.form, key, val);
  }

  get isFormValid() {
    return (
      this.form.nomor_formulir &&
      this.form.tanggal_supervisi &&
      this.form.waktu_mulai &&
      this.form.waktu_selesai &&
      this.form.supervisor_nama
    );
  }

  @Watch("value")
  onDialogOpen(val: boolean) {
    if (val) {
      if (this.editData && this.editData.id) {
        this.populateForm(this.editData);
      } else {
        this.form = this.getEmptyForm();
      }
    }
  }

  getEmptyForm() {
    const form: any = {
      nomor_formulir: "",
      tanggal_supervisi: "",
      waktu_mulai: "",
      waktu_selesai: "",
      supervisor_nama: "",
      supervisor_jabatan: "",
      temuan_utama: "",
      rencana_tindak_lanjut: "",
      supervisor_ttd_nama: "",
      supervisor_ttd_tanggal: "",
      kepala_unit_ttd_nama: "",
      kepala_unit_ttd_tanggal: "",
    };

    for (const item of this.allItems) {
      form[item.key] = null;
      form[item.key + "_masalah"] = "";
      form[item.key + "_rekomendasi"] = "";
    }

    return form;
  }

  buildPayload() {
    const payload: any = { ...this.form };
    for (const item of this.allItems) {
      if (payload[item.key] === null || payload[item.key] === undefined) {
        delete payload[item.key];
      }
    }
    return payload;
  }

  get tanggalSupervisiDate(): Date | null {
    return composeDate(this.form.tanggal_supervisi);
  }
  set tanggalSupervisiDate(val: Date | null) {
    this.$set(this.form, "tanggal_supervisi", toDateString(val) || "");
  }

  get waktuMulaiDate(): Date | null {
    if (!this.form.waktu_mulai) return null;
    return composeDate(JAM_CARRIER, String(this.form.waktu_mulai).slice(0, 5));
  }
  set waktuMulaiDate(val: Date | null) {
    this.$set(this.form, "waktu_mulai", toTimeString(val));
  }

  get waktuSelesaiDate(): Date | null {
    if (!this.form.waktu_selesai) return null;
    return composeDate(JAM_CARRIER, String(this.form.waktu_selesai).slice(0, 5));
  }
  set waktuSelesaiDate(val: Date | null) {
    this.$set(this.form, "waktu_selesai", toTimeString(val));
  }

  get supervisorTtdTanggalDate(): Date | null {
    return composeDate(this.form.supervisor_ttd_tanggal);
  }
  set supervisorTtdTanggalDate(val: Date | null) {
    this.$set(this.form, "supervisor_ttd_tanggal", toDateString(val) || "");
  }

  get kepalaUnitTtdTanggalDate(): Date | null {
    return composeDate(this.form.kepala_unit_ttd_tanggal);
  }
  set kepalaUnitTtdTanggalDate(val: Date | null) {
    this.$set(this.form, "kepala_unit_ttd_tanggal", toDateString(val) || "");
  }

  populateForm(data: any) {
    this.form = { ...this.getEmptyForm() };
    for (const key of Object.keys(this.form)) {
      if (data[key] !== undefined && data[key] !== null) {
        this.form[key] = data[key];
      }
    }
    if (this.form.tanggal_supervisi) {
      this.form.tanggal_supervisi = this.form.tanggal_supervisi.substring(0, 10);
    }
    if (this.form.waktu_mulai) {
      this.form.waktu_mulai = String(this.form.waktu_mulai).substring(0, 5);
    }
    if (this.form.waktu_selesai) {
      this.form.waktu_selesai = String(this.form.waktu_selesai).substring(0, 5);
    }
    if (this.form.supervisor_ttd_tanggal) {
      this.form.supervisor_ttd_tanggal = this.form.supervisor_ttd_tanggal.substring(0, 10);
    }
    if (this.form.kepala_unit_ttd_tanggal) {
      this.form.kepala_unit_ttd_tanggal = this.form.kepala_unit_ttd_tanggal.substring(0, 10);
    }
  }

  async save() {
    this.saving = true;
    try {
      if (this.isEdit) {
        await SupervisiLaundryService.update(this.editData.id, this.buildPayload());
        appModule.sendSuccessNotice("Supervisi berhasil diperbarui");
      } else {
        await SupervisiLaundryService.create(this.buildPayload());
        appModule.sendSuccessNotice("Supervisi berhasil ditambahkan");
      }
      this.$emit("saved");
      this.close();
    } finally {
      this.saving = false;
    }
  }

  close() {
    this.dialogVisible = false;
  }
}
